import * as browser from './browser';
import * as tools from './tools'

export default {
    browser,
    tools,
};
